module.exports = __webpack_public_path__ + "img/ic_exit.aa87bf1d.svg";